import { render, staticRenderFns } from "./AssociationDashboardView.vue?vue&type=template&id=4950e2e1&scoped=true&"
import script from "./AssociationDashboardView.vue?vue&type=script&lang=ts&"
export * from "./AssociationDashboardView.vue?vue&type=script&lang=ts&"
import style0 from "./AssociationDashboardView.vue?vue&type=style&index=0&id=4950e2e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4950e2e1",
  null
  
)

export default component.exports